const initState = {
  userCredits: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case "CHANGE_USER_CREDITS":
      return {
        ...state,
        userCredits: action.payload,
      };
    default:
      return state;
  }
};
